module.exports = __webpack_public_path__ + "static/media/on-the-office-animate.2d7dbdfb.svg";